import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getPaymentMethods(authorization,data) {
  const url = `${API_URL}/webclient/in-web-purchase/payment-methods`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getClientKey(authorization) {
  const url = `${API_URL}/webclient/in-web-purchase/client-key`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePayment(authorization,data) {
  const url = `${API_URL}/webclient/in-web-purchase/create-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePaymentWeChat(authorization,data) {
  const url = `${API_URL}/webclient/in-web-purchase/wechat/create-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function confirmPayment(authorization,data) {
  const url = `${API_URL}/webclient/in-web-purchase/confirm-transaction-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function getPaymentMethodsSubscription(authorization,data) {
  const url = `${API_URL}/webclient/subscription/payment-methods`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePaymentSubscription(authorization,data) {
  const url = `${API_URL}/webclient/subscription/create-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePaymentSubscriptionWeChat(authorization,data) {
  const url = `${API_URL}/webclient/subscription/wechat/create-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePaymentSubscriptionPayMongo(authorization,data) {
  const url = `${API_URL}/webclient/subscription/paymongo/create-source`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function confirmPaymentSubscription(authorization,data) {
  const url = `${API_URL}/webclient/subscription/confirm-payment`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}
export async function confirmPaymentSubscriptionPayMongo(authorization,data) {
  const url = `${API_URL}/webclient/subscription/paymongo/confirm-payment`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function cancelSubscription(authorization) {
  const url = `${API_URL}/webclient/subscription/cancel-subscription`;
  return axios({
    url,
    method: 'post',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function makePaymentDonation(authorization,data) {
  const url = `${API_URL}/webclient/donation/create-session`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function cancelDonation(authorization,data) {
  const url = `${API_URL}/webclient/donation/cancel`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function changeAmountSubscription(authorization,data) {
  const url = `${API_URL}/webclient/subscription/change-amount`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function updatePayment(authorization,data) {
  const url = `${API_URL}/webclient/subscription/update-payment-create-session`;
  return axios({
    url,
    method: 'post',
    data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}




// WEBPACK FOOTER //
// ./src/services/payment.js